import "core-js/modules/es.array.map";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React from 'react';
import PropTypes from 'prop-types';
/**
 * Represents an error message component for an input control.
 */

var InputErrorMessage = function InputErrorMessage(_ref) {
  var children = _ref.children,
      id = _ref.id;

  if (typeof children !== 'string' && !Array.isArray(children)) {
    console.warn('Invalid error message supplied to InputErrorMessage. Valid error messages must be a string or an array of strings');
    return null;
  }

  return typeof id === 'string' ? React.createElement("span", {
    className: "wds-c-input-error-message",
    id: id
  }, children) : children.map(function (error, index) {
    return React.createElement("span", {
      className: "wds-c-input-error-message",
      id: id[index],
      key: error
    }, error);
  });
};

InputErrorMessage.propTypes = {
  // id of the input error element, set the aria-describedBy of the input field the error message is for to this id
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  // a string or an array of strings. When multiple errors messages are provided, each one will be displayed on a new line
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired
};
export default InputErrorMessage;